/* ==========================================================================
   FIX: Text von "Weitere Bezahlmöglichkeiten" auf "Zum Checkout" ändern
   Grund: Text wird von Shopifys eigenem Payment-Button-Skript injiziert,
   lädt teils asynchron -> MutationObserver statt einmaligem DOM-Zugriff
   Status: aktiv
   ========================================================================== */
(function () {
  function relabelMoreOptionsLink(link) {
    if (link && link.textContent.trim() !== 'Zum Checkout') {
      link.textContent = 'Zum Checkout';
    }
  }

  document.querySelectorAll('#more-payment-options-link, .shopify-payment-button__more-options')
    .forEach(relabelMoreOptionsLink);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.id === 'more-payment-options-link' || node.classList?.contains('shopify-payment-button__more-options')) {
          relabelMoreOptionsLink(node);
        }
        node.querySelectorAll?.('#more-payment-options-link, .shopify-payment-button__more-options')
          .forEach(relabelMoreOptionsLink);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();